import React from 'react'
import { EstateStatusStyled } from './estatesStyle'
import { injectIntl } from 'gatsby-plugin-intl'

const EstateStatus = ({ inProgress, done, trailer, premiere, completed, intl }) => {
  return (
    <EstateStatusStyled>
      <p className={`status ${inProgress ? 'in-progress' : ''}${done ? 'done' : ''}${trailer ? 'trailer' : ''}${premiere ? 'premiere' : ''}${completed ? 'completed' : ''}`}>
        {inProgress && intl.formatMessage({ id: "estate.status.inProgress" })}
        {done && intl.formatMessage({ id: "estate.status.done" })}
        {trailer && intl.formatMessage({ id: "estate.status.preview" })}
        {premiere && intl.formatMessage({ id: "estate.status.premiere" })}
        {completed && intl.formatMessage({ id: "estate.status.completed" })}
      </p>
    </EstateStatusStyled>
  );
};

export default injectIntl(EstateStatus);